// test1258
(1258 && 0);
